import { makeHttp } from "@common/utils/http";
import { makeTodoService } from "@common/services/todo-service";
import { makeCalendarService } from "@common/services/calendar-event-service";
import { makeUserService } from "@common/services/user-service";
import { makeSpaceService } from "@common/services/space-service";
import { makeRealtimeService } from "@common/services/realtime/realtime-service";
import { makeTrpcClient } from "@common/api-interface/trpc-client";
import { makeFeatureFlagService } from "@web/src/app/services/feature-flag-service";
import { makePurchasesApi } from "@web/src/app/services/purchases-api";
import { options } from "@common/consts/options";

// Set in next.config.js
if (!process.env.version) throw new Error('Missing "version" env var');
console.log("** App Version:", process.env.version);

export const trpc = makeTrpcClient("/api/trpc", process.env.version, "web");
export const Http = makeHttp("/api", { "X-Client-Version": process.env.version, "X-Client-Platform": "web" });
export const realtimeService = makeRealtimeService({
  getAccessToken: () => Http.getAccessToken(),
});
export const todoService = makeTodoService({ Http, trpc: trpc.client, realtimeService });
export const userService = makeUserService({ Http, trpc: trpc.client });
export const spaceService = makeSpaceService({ Http, trpcClient: trpc.client });
export const featureFlagService = makeFeatureFlagService();
export const purchasesApi = makePurchasesApi({ trpc: trpc.client });
export const eventService = makeCalendarService({ trpc: trpc.client });

// if window closes, flush updates
if (typeof window !== "undefined") {
  window.addEventListener("beforeunload", () => {
    todoService.dispatchUpdates();
    eventService.dispatchUpdates();
  });
}
